import React from 'react';
import PropTypes from 'prop-types';

export default function PopoverHoc(props) {
  const {
    children, style, classes,
    id, Component, className, anchorOrigin,
    open, onClose, PaperProps,
    transformOrigin, elevation, anchorEl
  } = props;
  return (
    <Component
      id={id}
      open={open}
      className={className}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}
      elevation={elevation}
      classes={classes}
      style={style}
      PaperProps={PaperProps}
    >
      {children}
    </Component>
  );
}

PopoverHoc.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]).isRequired,
  style: PropTypes.object,
  PaperProps: PropTypes.object,
  anchorEl: PropTypes.object,
  transformOrigin: PropTypes.object,
  anchorOrigin: PropTypes.object,
  elevation: PropTypes.number,
  classes: (props, propName, componentName) => {
    const classProp = Object.keys(props[propName]) || {};
    for (let index = 0; index < classProp.length; index += 1) {
      if (['paper'].indexOf(classProp[index]) === -1) {
        return new Error(
          `Invalid prop '${propName}' supplied to ${componentName}. Validation failed.`
        );
      }
    }
    return false;
  },
  Component: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  className: PropTypes.string
};

PopoverHoc.defaultProps = {
  style: {},
  classes: {},
  id: '',
  className: '',
  anchorEl: {},
  anchorOrigin: {},
  transformOrigin: {},
  elevation: 0,
  PaperProps: {}
};



// WEBPACK FOOTER //
// ./src/widgets/Popover/Variants/PopoverHoc.jsx